import Curl from '$common/utils/curl/browser-curl';
import AppCurl from '$common/utils/curl/app-curl';
import UrlModules from '$common/utils/curl/browser-curl/url-modules';
import { isWownowApp } from '$common/utils/common'

export const pix = 'gateway_web';
const appgatewayHost = new UrlModules({ module: 'appgateway' });
const defaultCurl = (params, url, config) => new Curl().curl(params, `${appgatewayHost.host}/${pix}/${url}`, config);
const defaultAppCurl = (params, url, config) => new AppCurl().curl(params, `/${url}`, config);

export const getActivity = (params, config) => {
  return defaultCurl(params, `app/channel/activity/detail.do`, config);
}

export const receiveCoupon = (params, config, h5Login = false) => {
  if (isWownowApp && !h5Login) return defaultAppCurl(params, `app/channel/unified/receive.do`, config);
  return defaultCurl(params, `app/channel/unified/receive.do`, config);
}


export const activityLimit = (params, config) => {
  return defaultCurl(params, `app/channel/gonowaba/activityLimit`, config);
}


// 新增短链
export const getShortLint = (params, config) => {
  if (isWownowApp) return defaultAppCurl(params, `app/mobile-app-composition/short-lint/save`, config);
  return defaultCurl(params, `app/mobile-app-composition/short-lint/save`, config);
}
